module.exports = "/_next/static/images/062e7077ffb6ef2d46a354a05db78e44-credit-card-limit@3x.png";